import React from 'react';

const FileIconDeactivate = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-file-dactivate" data-testid="file-icon-deactivate" />
    </div>
  );
};

export default FileIconDeactivate;
